const project = JSON.parse(localStorage.getItem("project"));
const initialState = project ? { project } : { project: null };

export const proj = {
  namespaced: true,
  state: initialState,
  actions: {
  },
  mutations: {
    changeProjectSelected(state) {
      state.project = JSON.parse(localStorage.getItem("project"));
    },
    updateBuffer(state, payload) {
      state.project.storyboardscript = payload.storyboardscript;
      state.project.renderstoryboard = payload.renderstoryboard;
      state.project.approvalrender = payload.approvalrender;
    },
  },
};
